import { defaultConfig, defineConfig } from "@chakra-ui/react"
import { createSystem } from "@chakra-ui/react"
import { config as baseConfig } from "../theme"

const createStylingSystem = (cssRoot?: string, prefix?: string) =>
  createSystem(
    defaultConfig,
    defineConfig({
      ...baseConfig,
      ...(cssRoot && { cssVarsRoot: cssRoot }),
      ...(prefix && { cssVarsPrefix: prefix }),
    }),
  )

export default createStylingSystem
